import '../stylesheets/themes/baladapp'

const images = require.context('../images/baladapp', true)